var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('p-button',{staticClass:"mb-4",attrs:{"type":"success"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"bi bi-arrow-left"}),_vm._v(" Zurück")])],1),_c('div',{staticClass:"row"},[_c('iframe',{attrs:{"src":_vm.pdfUrl,"id":"frame","width":"1300","height":"1700"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }